import { useState, useRef, useEffect } from 'react'
import { Plus } from 'lucide-react'

interface FolderCreateCardProps {
  onCreate: (name: string) => void
}

export function FolderCreateCard({ onCreate }: FolderCreateCardProps) {
  const [editing, setEditing] = useState(false)
  const [value, setValue] = useState('')
  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (editing && inputRef.current) {
      inputRef.current.focus()
    }
  }, [editing])

  const commit = () => {
    const trimmed = value.trim()
    if (trimmed) {
      onCreate(trimmed)
    }
    setValue('')
    setEditing(false)
  }

  const cancel = () => {
    setValue('')
    setEditing(false)
  }

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      commit()
    } else if (e.key === 'Escape') {
      e.preventDefault()
      cancel()
    }
  }

  const handleBlur = () => {
    const trimmed = value.trim()
    if (trimmed) {
      commit()
    } else {
      cancel()
    }
  }

  if (editing) {
    return (
      <div className="flex items-center gap-2 px-3 py-2.5 rounded-lg border border-dashed border-border min-w-[140px] sm:min-w-[160px]">
        <Plus className="w-3 h-3 text-muted-foreground shrink-0" />
        <input
          ref={inputRef}
          type="text"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={handleKeyDown}
          onBlur={handleBlur}
          placeholder="Folder name"
          className="flex-1 text-sm bg-transparent outline-none min-w-0"
        />
      </div>
    )
  }

  return (
    <button
      type="button"
      className="flex items-center gap-2 px-3 py-2.5 rounded-lg border border-dashed border-border
        hover:border-foreground/30 transition-colors cursor-pointer min-w-[140px] sm:min-w-[160px]
        text-muted-foreground hover:text-foreground"
      onClick={() => setEditing(true)}
    >
      <Plus className="w-3 h-3 shrink-0" />
      <span className="text-sm">New</span>
    </button>
  )
}
